import { Box, Button, FormLabel, Grid, IconButton, Input, Modal } from '@mui/material';
import { CSVLink } from 'react-csv';
import React from 'react';
import Iconify from '../../iconify/Iconify';

function Addemployermodel(props) {
  const {
    Edit,
    modelopen,
    state,
    handleChange,
    fielderror,
    handleClose,
    handleaddok,
    handleeditok,
    Filename,
    withdrawalData,
  } = props;

  const style1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 10,
    p: 2,
    transition: 'left 0.5s ease-in-out',
  };
  const style2 = {
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <>
      <Modal
        style={style2}
        open={modelopen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style1, left: modelopen ? '50%' : '-50%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h2>{Edit ? 'Update Employer' : 'Add Employer'}</h2>
            <Iconify style={{ cursor: 'pointer' }} onClick={handleClose} icon={'material-symbols:close'} />
          </div>
          <Grid container spacing={3}>
            {/* Employer name */}
            <Grid sx={style2} item xs={12} sm={12} md={12} xl={12}>
              <FormLabel>EmployerName :</FormLabel>
              <Input
                type="text"
                name="EmployerName"
                onChange={handleChange}
                label="title"
                value={state?.EmployerName}
              />
              <div style={{ color: 'red' }}>{fielderror.EmployerName}</div>
            </Grid>
            {/* Employer Email */}

            {/* <Grid sx={style2} item xs={12} sm={12} md={12} xl={12}>
              <FormLabel>EmployerId :</FormLabel>
              <Input
                type="text"
                name="EmployerId"
                onChange={handleChange}
                label="EmployerId"
                value={state?.EmployerId}
              />
              <div style={{ color: 'red' }}>{fielderror.EmployerId}</div>
            </Grid> */}

            {/* Email */}

            <Grid sx={style2} item xs={12} sm={12} md={12} xl={12}>
              <FormLabel>Email:</FormLabel>
              <Input type="text" name="Email" onChange={handleChange} label="Email" value={state?.Email} />
              <div style={{ color: 'red' }}>{fielderror.Email}</div>
            </Grid>

            {/* Phone */}

            <Grid sx={style2} item xs={12} sm={12} md={12} xl={12}>
              <FormLabel>Phone:</FormLabel>
              <Input type="text" name="Phone" onChange={handleChange} label="Phone" value={state?.Phone} />
              <div style={{ color: 'red' }}>{fielderror.Phone}</div>
            </Grid>

            {/* Address */}
            <Grid sx={style2} item xs={12} sm={12} md={12} xl={12}>
              <FormLabel>Address:</FormLabel>
              <Input type="text" name="Address" onChange={handleChange} label="Basic" value={state?.Address} />
              <div style={{ color: 'red' }}>{fielderror.Address}</div>
            </Grid>

            {/* AdvanceRepayment */}
            <Grid sx={style2} item xs={12} sm={6} md={6} xl={6}>
              <FormLabel>OwnerShip :</FormLabel>
              <Input type="text" name="OwnerShip" onChange={handleChange} label="title" value={state?.OwnerShip} />
              <div style={{ color: 'red' }}>{fielderror.OwnerShip}</div>
            </Grid>
            {/* Bank */}
            <Grid sx={style2} item xs={12} sm={6} md={6} xl={6}>
              <FormLabel>Industry:</FormLabel>
              <Input type="text" name="Industry" onChange={handleChange} label="Basic" value={state?.Industry} />
              <div style={{ color: 'red' }}>{fielderror.Industry}</div>
            </Grid>

            {/* Basic */}
            <Grid sx={style2} item xs={12} sm={6} md={6} xl={6}>
              <FormLabel>HighestSalary:</FormLabel>
              <Input
                type="text"
                name="HighestSalary"
                onChange={handleChange}
                label="HighestSalary"
                value={state?.HighestSalary}
              />
              <div style={{ color: 'red' }}>{fielderror.HighestSalary}</div>
            </Grid>

            {/* Bonus */}
            <Grid sx={style2} item xs={12} sm={6} md={6} xl={6}>
              <FormLabel>TotalSalaryOutflow:</FormLabel>
              <Input
                type="text"
                name="TotalSalaryOutflow"
                onChange={handleChange}
                label="TotalSalaryOutflow"
                value={state?.TotalSalaryOutflow}
              />
              <div style={{ color: 'red' }}>{fielderror.TotalSalaryOutflow}</div>
            </Grid>

            {/* Website */}

            <Grid sx={style2} item xs={12} sm={6} md={6} xl={6}>
              <FormLabel>Website :</FormLabel>
              <Input type="text" name="Website" onChange={handleChange} label="Website" value={state?.Website} />
              <div style={{ color: 'red' }}>{fielderror.Website}</div>
            </Grid>

            {/* Designation */}
            <Grid sx={style2} item xs={12} sm={6} md={6} xl={6}>
              <FormLabel>SocialMedia:</FormLabel>
              <Input
                type="text"
                name="SocialMedia"
                onChange={handleChange}
                label="SocialMedia"
                value={state?.SocialMedia}
              />
              <div style={{ color: 'red' }}>{fielderror.SocialMedia}</div>
            </Grid>

            {/* SPOCContactInfo */}

            <Grid sx={style2} item xs={12} sm={6} md={6} xl={6}>
              <FormLabel>SPOCContactInfo:</FormLabel>
              <Input
                type="text"
                name="SPOCContactInfo"
                onChange={handleChange}
                label="SPOCContactInfo"
                value={state?.SPOCContactInfo}
              />
              <div style={{ color: 'red' }}>{fielderror.SPOCContactInfo}</div>
            </Grid>
            {/* TransactionFee  */}
            <Grid sx={style2} item xs={12} sm={6} md={6} xl={6}>
              <FormLabel>TransactionFee :</FormLabel>
              <Input
                type="text"
                name="TransactionFee "
                onChange={handleChange}
                label="TransactionFee "
                value={state?.TransactionFee}
              />
              <div style={{ color: 'red' }}>{fielderror.TransactionFee}</div>
            </Grid>

            {/* SPOCDesign */}
            <Grid sx={style2} item xs={12} sm={6} md={6} xl={6}>
              <FormLabel>SPOCDesign :</FormLabel>
              <Input
                type="text"
                name="SPOCDesign"
                onChange={handleChange}
                label="SPOCDesign"
                value={state?.SPOCDesign}
              />
              <div style={{ color: 'red' }}>{fielderror.SPOCDesign}</div>
            </Grid>
          </Grid>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            {/* {Edit && (
              <CSVLink
                style={{ color: 'white', textDecoration: 'none' }}
                // data={withdrawalData}
                filename="sample.csv"
                target=""
              >
                <Button style={{ marginTop: '10px', marginRight: '10px' }} variant="contained">
                  Download Data
                </Button>
              </CSVLink>
            )} */}
            {Edit ? (
              <Button onClick={() => handleeditok()} style={{ marginTop: '10px' }} variant="contained">
                Update
              </Button>
            ) : (
              <Button onClick={() => handleaddok()} style={{ marginTop: '10px' }} variant="contained">
                Add
              </Button>
            )}

            <Button style={{ marginTop: '10px', marginLeft: '10px' }} onClick={handleClose} variant="outlined">
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default Addemployermodel;
